export default __webpack_public_path__ + "static/media/js.80ec44d1.svg";